import ListaOrganigrama4 from './ListaOrganigrama4';
import OrganigramaModalState from '../../context/OrganigramaContext/OrganigramaModalState';
import './Organigrama.css'

const Body = () =>{
    return(
    <>
    <OrganigramaModalState>
        <ListaOrganigrama4 />
    </OrganigramaModalState>
    </>
    )
}


export default Body;